import { render, staticRenderFns } from "./Debtor.vue?vue&type=template&id=086bf817&scoped=true&"
import script from "./Debtor.vue?vue&type=script&lang=js&"
export * from "./Debtor.vue?vue&type=script&lang=js&"
import style0 from "./Debtor.vue?vue&type=style&index=0&id=086bf817&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086bf817",
  null
  
)

export default component.exports